export var DATASOURCE_TABLE_LAYOUTS = ['full-width', 'center', 'wide'];